import { Dispatch, SetStateAction, useState } from "react";
import { Button } from "react-bootstrap";
import * as APIModels from "../../../models";
import moment from "moment";
import QueueDetailRow from "./QueueDetailRow";
import {
    QueueService,
    SubmissionService,
} from "../../../services/SubmissionService";
import { Globals } from "../../../helpers/globals";
import { SnackBarState } from "./FileQueue";

const styles = {
    detailRow: {
        paddingLeft: "100px",
    },
};

export interface QueueRowProps {
    attorneyQueue: APIModels.AttorneyQueue;
}

// This component will be used to render the content of the attorney's queue.
// It will display different background colors depending on the time that a
// submission has been in the queue.
// The background color is an optional property that can be passed when calling
// the component.
export default function QueueRow({
    attorneyQueue,
    filter,
    state,
    color,
    snackBarMessage,
}: {
    attorneyQueue: APIModels.AttorneyQueue;
    filter: string;
    state: string;
    color?: string | undefined;
    snackBarMessage: (message: string) => void;
}) {
    const currentUser = Globals.currentUserValue;

    const details: APIModels.QueuedSubmission[] = [];
    const [fileDetailRows, setFileDetailRows] = useState(details);
    const showFiles = (row: HTMLElement) => {
        if (
            fileDetailRows.length === 0 &&
            row.className.indexOf("dropdown") < 0
        ) {
            QueueService.getQueueByAttorney({
                attorneyId: attorneyQueue.attorneyID!,
                filter: filter,
                state: state,
            }).then(
                (resp) => {
                    setFileDetailRows(resp.data || []);
                },
                (error) => {
                    console.log(error);
                }
            );
        } else {
            setFileDetailRows([]);
        }
    };

    const processByAttorney = (attorneyId: string) => {
        console.log("cancel all");
    };

    const cancelAll = (attorneyId: string) => {
        SubmissionService.cancelAll({ attorneyId, body: {} }).then(
            (resp) => {
                if (resp.successful) {
                    window.location.reload();
                } else {
                    window.location.reload();
                }
            },
            (error) => {
                console.log(error);
                //setError(error);
            }
        );
    };

    const cancelAutoFile = (attorneyId: string) => {
        SubmissionService.cancelAutoFile({ attorneyId, body: {} }).then(
            (resp) => {
                if (resp.successful) {
                    window.location.reload();
                } else {
                    window.location.reload();
                }
            },
            (error) => {
                console.log(error);
                //setError(error);
            }
        );
    };

    const holdlAll = (attorneyId: string) => {
        console.log("cancel all");
    };

    // Auto File
    const autoFile = (attorneyId: string) => {
        SubmissionService.autofile({ attorneyId }).then(
            (resp) => {
                window.location.reload();
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const syncAttorney = (attorneyId: string) => {
        SubmissionService.syncByAttorney({ attorneyId }).then(
            (resp) => {
                window.location.reload();
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const aiPopulateAttorney = (attorneyId: string) => {
        SubmissionService.aiPopulateByAttorney({
            attorneyId,
            filter,
            state,
        }).then(
            (resp) => {
                console.log("sent to server");
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const ColoredRow = (props: { color: string | undefined }): JSX.Element => {
        const color = props.color;
        if (color === "yellow") {
            return (
                <tr
                    style={{ background: "#f9faaf" }}
                    onClick={(e) => {
                        const target = e.target as Element;
                        if (
                            target.className == "" ||
                            target.className == "ms-2"
                        )
                            showFiles(e.currentTarget);
                    }}
                >
                    <td>
                        {filter !== "preprocess" ? (
                            <a
                                className="btn btn-primary"
                                href={`/efile?attorneyId=${
                                    attorneyQueue.attorneyID
                                }&filter=${filter ?? ""}&state=${state ?? ""}`}
                            >
                                Process
                            </a>
                        ) : (
                            <a
                                className="btn btn-primary"
                                href={`/preprocess?attorneyId=${
                                    attorneyQueue.attorneyID
                                }&filter=${filter ?? ""}&state=${state ?? ""}`}
                            >
                                Split
                            </a>
                        )}
                        &nbsp;
                        <a
                            className="btn btn-danger"
                            href="#"
                            onClick={() => cancelAll(attorneyQueue.attorneyID!)}
                        >
                            Cancel All
                        </a>
                    </td>
                    <td>
                        <a href="javascript: void(0);" className="text-dark">
                            <span className="ms-2">{attorneyQueue.name}</span>
                        </a>
                    </td>

                    <td>{attorneyQueue.submissionCount}</td>

                    <td>
                        {attorneyQueue.emergency && (
                            <span className="badge bg-danger">Emergency</span>
                        )}
                    </td>
                    <td>
                        {moment
                            .utc(attorneyQueue.oldestFileDate)
                            .local()
                            .format("MMMM Do YYYY, h:mm:ss a")}
                    </td>
                    <td>
                        <div className="btn-group dropdown">
                            <a
                                href="#"
                                className="dropdown-toggle arrow-none btn btn-light btn-sm"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <i className="mdi mdi-dots-horizontal"></i>
                            </a>
                            <div className="dropdown-menu dropdown-menu-end">
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() =>
                                        autoFile(attorneyQueue.attorneyID!)
                                    }
                                >
                                    <i className="mdi mdi-pencil me-2 text-muted font-18 vertical-middle"></i>
                                    Auto-File
                                </a>
                                {currentUser!.role!.key! >= 500 ? (
                                    <a
                                        className="dropdown-item"
                                        href="#"
                                        onClick={() =>
                                            cancelAutoFile(
                                                attorneyQueue.attorneyID!
                                            )
                                        }
                                    >
                                        <i className="mdi mdi-file-cancel-outline me-2 text-muted font-18 vertical-middle"></i>
                                        Cancel Auto-File
                                    </a>
                                ) : (
                                    <></>
                                )}
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() =>
                                        syncAttorney(attorneyQueue.attorneyID!)
                                    }
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Sync
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() =>
                                        cancelAll(attorneyQueue.attorneyID!)
                                    }
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Cancel All
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() =>
                                        holdlAll(attorneyQueue.attorneyID!)
                                    }
                                >
                                    <i className="mdi mdi-delete me-2 text-muted font-18 vertical-middle"></i>
                                    Hold All
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => {
                                        window.location.href =
                                            "/admin/attorneyedit/" +
                                            attorneyQueue.attorneyID!;
                                    }}
                                >
                                    <i className="ri-scales-line me-2 text-muted font-18 vertical-middle"></i>
                                    Edit Attorney
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() =>
                                        aiPopulateAttorney(
                                            attorneyQueue.attorneyID!
                                        )
                                    }
                                >
                                    <i className="mdi mdi-robot-dead-outline me-2 text-muted font-18 vertical-middle"></i>
                                    Populate with AI
                                </a>
                            </div>
                        </div>
                    </td>
                </tr>
            );
        } else if (color === "red") {
            return (
                <tr
                    style={{ background: "#fca9a9" }}
                    onClick={(e) => {
                        const target = e.target as Element;
                        if (
                            target.className == "" ||
                            target.className == "ms-2"
                        )
                            showFiles(e.currentTarget);
                    }}
                >
                    <td>
                        {filter !== "preprocess" ? (
                            <a
                                className="btn btn-primary"
                                href={`/efile?attorneyId=${
                                    attorneyQueue.attorneyID
                                }&filter=${filter ?? ""}&state=${state ?? ""}`}
                            >
                                Process
                            </a>
                        ) : (
                            <a
                                className="btn btn-primary"
                                href={`/preprocess?attorneyId=${
                                    attorneyQueue.attorneyID
                                }&filter=${filter ?? ""}&state=${state ?? ""}`}
                            >
                                Split
                            </a>
                        )}
                        &nbsp;
                        <a
                            className="btn btn-danger"
                            href="#"
                            onClick={() => cancelAll(attorneyQueue.attorneyID!)}
                        >
                            Cancel All
                        </a>
                    </td>
                    <td>
                        <a href="javascript: void(0);" className="text-dark">
                            <span className="ms-2">{attorneyQueue.name}</span>
                        </a>
                    </td>

                    <td>{attorneyQueue.submissionCount}</td>

                    <td>
                        {attorneyQueue.emergency && (
                            <span className="badge bg-danger">Emergency</span>
                        )}
                    </td>
                    <td>
                        {moment
                            .utc(attorneyQueue.oldestFileDate)
                            .local()
                            .format("MMMM Do YYYY, h:mm:ss a")}
                    </td>
                    <td>
                        <div className="btn-group dropdown">
                            <a
                                href="#"
                                className="dropdown-toggle arrow-none btn btn-light btn-sm"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <i className="mdi mdi-dots-horizontal"></i>
                            </a>
                            <div className="dropdown-menu dropdown-menu-end">
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={(e) => {
                                        autoFile(attorneyQueue.attorneyID!);
                                        e.stopPropagation();
                                    }}
                                >
                                    <i className="mdi mdi-pencil me-2 text-muted font-18 vertical-middle"></i>
                                    Auto-File
                                </a>
                                {currentUser!.role!.key! >= 500 ? (
                                    <a
                                        className="dropdown-item"
                                        href="#"
                                        onClick={() =>
                                            cancelAutoFile(
                                                attorneyQueue.attorneyID!
                                            )
                                        }
                                    >
                                        <i className="mdi mdi-file-cancel-outline me-2 text-muted font-18 vertical-middle"></i>
                                        Cancel Auto-File
                                    </a>
                                ) : (
                                    <></>
                                )}
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() =>
                                        syncAttorney(attorneyQueue.attorneyID!)
                                    }
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Sync
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() =>
                                        cancelAll(attorneyQueue.attorneyID!)
                                    }
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Cancel All
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() =>
                                        holdlAll(attorneyQueue.attorneyID!)
                                    }
                                >
                                    <i className="mdi mdi-delete me-2 text-muted font-18 vertical-middle"></i>
                                    Hold All
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => {
                                        window.location.href =
                                            "/admin/attorneyedit/" +
                                            attorneyQueue.attorneyID!;
                                    }}
                                >
                                    <i className="ri-scales-line me-2 text-muted font-18 vertical-middle"></i>
                                    Edit Attorney
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() =>
                                        aiPopulateAttorney(
                                            attorneyQueue.attorneyID!
                                        )
                                    }
                                >
                                    <i className="mdi mdi-robot-dead-outline me-2 text-muted font-18 vertical-middle"></i>
                                    Populate with AI
                                </a>
                            </div>
                        </div>
                    </td>
                </tr>
            );
        } else {
            return (
                <tr
                    onClick={(e) => {
                        const target = e.target as Element;
                        if (
                            target.className == "" ||
                            target.className == "ms-2"
                        )
                            showFiles(e.currentTarget);
                    }}
                >
                    <td>
                        {filter !== "preprocess" ? (
                            <a
                                className="btn btn-primary"
                                href={`/efile?attorneyId=${
                                    attorneyQueue.attorneyID
                                }&filter=${filter ?? ""}&state=${state ?? ""}`}
                            >
                                Process
                            </a>
                        ) : (
                            <a
                                className="btn btn-primary"
                                href={`/preprocess?attorneyId=${
                                    attorneyQueue.attorneyID
                                }&filter=${filter ?? ""}&state=${state ?? ""}`}
                            >
                                Split
                            </a>
                        )}
                        &nbsp;
                        <a
                            className="btn btn-danger"
                            href="#"
                            onClick={() => cancelAll(attorneyQueue.attorneyID!)}
                        >
                            Cancel All
                        </a>
                    </td>
                    <td>
                        <a href="javascript: void(0);" className="text-dark">
                            <span className="ms-2">{attorneyQueue.name}</span>
                        </a>
                    </td>

                    <td>{attorneyQueue.submissionCount}</td>

                    <td>
                        {attorneyQueue.emergency && (
                            <span className="badge bg-danger">Emergency</span>
                        )}
                    </td>
                    <td>
                        {moment
                            .utc(attorneyQueue.oldestFileDate)
                            .local()
                            .format("MMMM Do YYYY, h:mm:ss a")}
                    </td>
                    <td>
                        <div className="btn-group dropdown">
                            <a
                                href="#"
                                className="dropdown-toggle arrow-none btn btn-light btn-sm"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <i className="mdi mdi-dots-horizontal"></i>
                            </a>
                            <div className="dropdown-menu dropdown-menu-end">
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() =>
                                        autoFile(attorneyQueue.attorneyID!)
                                    }
                                >
                                    <i className="mdi mdi-pencil me-2 text-muted font-18 vertical-middle"></i>
                                    Auto-File
                                </a>
                                {currentUser!.role!.key! >= 500 ? (
                                    <a
                                        className="dropdown-item"
                                        href="#"
                                        onClick={() =>
                                            cancelAutoFile(
                                                attorneyQueue.attorneyID!
                                            )
                                        }
                                    >
                                        <i className="mdi mdi-file-cancel-outline me-2 text-muted font-18 vertical-middle"></i>
                                        Cancel Auto-File
                                    </a>
                                ) : (
                                    <></>
                                )}

                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() =>
                                        syncAttorney(attorneyQueue.attorneyID!)
                                    }
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Sync
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() =>
                                        cancelAll(attorneyQueue.attorneyID!)
                                    }
                                >
                                    <i className="mdi mdi-check-all me-2 text-muted font-18 vertical-middle"></i>
                                    Cancel All
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() =>
                                        holdlAll(attorneyQueue.attorneyID!)
                                    }
                                >
                                    <i className="mdi mdi-delete me-2 text-muted font-18 vertical-middle"></i>
                                    Hold All
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => {
                                        window.location.href =
                                            "/admin/attorneyedit/" +
                                            attorneyQueue.attorneyID!;
                                    }}
                                >
                                    <i className="ri-scales-line me-2 text-muted font-18 vertical-middle"></i>
                                    Edit Attorney
                                </a>
                                <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() =>
                                        aiPopulateAttorney(
                                            attorneyQueue.attorneyID!
                                        )
                                    }
                                >
                                    <i className="mdi mdi-robot-dead-outline me-2 text-muted font-18 vertical-middle"></i>
                                    Populate with AI
                                </a>
                            </div>
                        </div>
                    </td>
                </tr>
            );
        }
    };

    const getColorNeeded = (uploadedDateTime: Date) => {
        const oldest = uploadedDateTime ? uploadedDateTime : "02/23/1996";
        const oldmom = moment.utc(oldest).local();
        const newest = moment(new Date(Date.now()));

        const time: number = newest.diff(oldmom, "minutes");
        if (time < 60 && time >= 30) {
            return "yellow";
        } else if (time >= 60) {
            return "red";
        }
        return "";
    };

    return (
        <>
            {" "}
            <ColoredRow color={color} />
            {fileDetailRows.length > 0 && (
                <tr className="queueDetailRow table-info">
                    <td colSpan={6} style={styles.detailRow}>
                        <table className="table table-hover m-0 table-centered dt-responsive nowrap w-100">
                            <thead>
                                <tr>
                                    <th className="fw-medium"></th>
                                    <th className="fw-medium">Status</th>
                                    <th className="fw-medium">ID</th>
                                    <th className="fw-medium">Filename</th>
                                    <th className="fw-medium">Uploaded</th>
                                    <th className="fw-medium">Emergency</th>
                                    <th className="fw-medium">Autofile</th>
                                    <th className="fw-medium"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {fileDetailRows.map((v, i) => (
                                    <QueueDetailRow
                                        submission={v}
                                        filter={filter}
                                        state={state}
                                        color={getColorNeeded(
                                            v.uploadedDateTime ?? new Date()
                                        )}
                                        snackBarMessage={snackBarMessage}
                                    />
                                ))}
                            </tbody>
                        </table>
                    </td>
                </tr>
            )}
        </>
    );
}
